module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_yushou-e4f32066bfcb66628e89e3f33aa77b1c.png";